/* src/app/cardholders/accounts/accounts.component.css */
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=accounts.component.css.map */
